module.exports = __webpack_public_path__ + "img/index3.daa7bd12.png";